import { Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-info-rgpd',
  templateUrl: './modal-info-rgpd.component.html',
  styleUrls: ['./modal-info-rgpd.component.scss'],
})
export class ModalInfoRgpdComponent {
  @ViewChild('contentInfoRGPD') contentInfoRGPD?: any;

  constructor(private modalService: NgbModal) {}
  openVertically(content: any) {
    this.modalService.open(content, { size: 'xl' });
  }

  // ngOnInit(): void {
  //   setTimeout(() => {
  //     this.openVertically(this.contentInfoRGPD);
  //   }, 100);
  // }
}
